/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { colors, borderRadius, shadows, typography } from '../../styles/theme';

const sectionStyles = css`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1rem;

  @media (min-width: 768px) {
    padding: 4rem 2rem;
  }
`;

const sectionHeaderStyles = css`
  text-align: center;
  margin-bottom: 3rem;

  h2 {
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize['2xl']};
    color: ${colors.text.primary};
    margin-bottom: 0.75rem;

    @media (min-width: 768px) {
      font-size: ${typography.fontSize['3xl']};
    }
  }

  p {
    color: ${colors.text.secondary};
    max-width: 600px;
    margin: 0 auto;
  }
`;

const gridStyles = css`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const cardStyles = css`
  background: white;
  border-radius: ${borderRadius['2xl']};
  padding: 2rem;
  box-shadow: ${shadows.md};
  position: relative;
  display: flex;
  flex-direction: column;

  .quote-icon {
    position: absolute;
    top: 1.25rem;
    right: 1.5rem;
    font-size: 3rem;
    line-height: 1;
    color: ${colors.primary[100]};
    font-family: Georgia, serif;
  }

  .stars {
    display: flex;
    gap: 2px;
    margin-bottom: 1rem;
  }

  .text {
    color: ${colors.text.secondary};
    font-size: ${typography.fontSize.sm};
    line-height: 1.7;
    margin-bottom: 1.5rem;
    font-style: italic;
    flex: 1;
  }

  .author {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .author-avatar {
    width: 44px;
    height: 44px;
    border-radius: ${borderRadius.full};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: ${typography.fontWeight.bold};
    color: white;
    font-size: ${typography.fontSize.sm};
  }

  .author-info {
    h4 {
      font-family: ${typography.fontFamily.heading};
      font-size: ${typography.fontSize.sm};
      font-weight: ${typography.fontWeight.semibold};
      color: ${colors.text.primary};
      margin-bottom: 0.15rem;
    }

    span {
      font-size: ${typography.fontSize.xs};
      color: ${colors.text.muted};
    }
  }
`;

const StarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={colors.secondary[400]} stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const testimonials = [
  {
    text: 'Gece yarısı aracım bozuldu, YolSepetiGO sayesinde 15 dakikada çekici geldi. Gerçekten hayat kurtarıcı bir uygulama!',
    name: 'Ahmet Y.',
    service: 'Çekici Hizmeti',
    avatarColor: colors.primary[500],
    initials: 'AY',
  },
  {
    text: 'Ev taşınması için kullandım. Ekip çok profesyoneldi, eşyalarıma özen gösterdiler. Fiyat da gayet uygundu.',
    name: 'Elif D.',
    service: 'Nakliye Hizmeti',
    avatarColor: '#16a34a',
    initials: 'ED',
  },
  {
    text: 'Kış ortasında akü bitti, bir telefon ile anında yardım geldi. 7/24 ulaşılabilir olmaları büyük avantaj.',
    name: 'Mehmet K.',
    service: 'Yol Yardım',
    avatarColor: colors.secondary[500],
    initials: 'MK',
  },
];

export default function TestimonialsSection() {
  return (
    <section css={sectionStyles}>
      <div css={sectionHeaderStyles}>
        <h2>Müşterilerimiz Ne Diyor?</h2>
        <p>Binlerce mutlu müşterimizden bazı yorumlar</p>
      </div>
      <div css={gridStyles}>
        {testimonials.map((t, i) => (
          <div key={i} css={cardStyles}>
            <span className="quote-icon" aria-hidden="true">"</span>
            <div className="stars" role="img" aria-label="5 üzerinden 5 yıldız">
              {Array.from({ length: 5 }).map((_, j) => (
                <StarIcon key={j} />
              ))}
            </div>
            <p className="text">{t.text}</p>
            <div className="author">
              <div className="author-avatar" style={{ background: t.avatarColor }}>
                {t.initials}
              </div>
              <div className="author-info">
                <h4>{t.name}</h4>
                <span>{t.service}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
